import type { WithT } from 'i18next';

export const formatLastActivity = (lastData: number, i18next: WithT): string => {
  const deltaHours = (new Date().getTime() / 1000 - lastData) / 3600;
  return deltaHours < 72
    ? i18next.t('common:format.hours', { value: Math.round(deltaHours) })
    : i18next.t('common:format.days', { value: Math.ceil(deltaHours / 24) });
};
